












































































































































































import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import TextField from '@/reusable/Form/TextField.vue';
import { AxiosVue } from '@/AxiosVue';
import { ServicioProxy } from '@/config/enums';
import SwitchForm from '@/reusable/Form/SwitchForm.vue';
import store from '@/store';
import { Validator } from 'vee-validate';
// import HandleErrors from '@/config/handleErrors';
import moment from 'moment';
import {
  emitFormChangeEvent,
  // formErrors,
  FormFieldDefMap,
  makeValidatorDictionary,
} from '@/reusable/Form/formUtils';
import FormFieldsContainer from '@/reusable/Form/FormFieldsContainer.vue';
import { Snotify } from '@/snotify/Snotify';
import { EstadoEntidad } from '../../config/enums';
import ValidaRut from '@/config/validaRut';
import { LoadingService } from '@/services/loadingService';
import _ from 'lodash';

// import { Proveedor } from './Proveedor';//borrar
import { Solicitud } from './Solicitud';
import {
  fetchCategorias,
  Categorias,
} from '@/pantallas/Solicitudes/fetchCategorias';
import {
  fetchSubCategorias,
  SubCategorias,
} from '@/pantallas/Solicitudes/fetchSubcategorias';
import { CreacionSolicitud } from '@/pantallas/Solicitudes/crearSolicitud';

@Component({
  components: {
    TextField,
    FormFieldsContainer,
  },
})
export default class SolicitudForm extends Vue {
  @Prop({ default: false }) modoVer: boolean;
  @Prop() solicitudSeleccionada: any;

  isFormValid: boolean = false;
  readonly $snotify: Snotify;
  readonly loadingService = new LoadingService();

  mensajeEstado: string = '';
  bloquedoCategoria: boolean = true;

  vr: ValidaRut = new ValidaRut();

  formFields: FormFieldDefMap = {
    nroCaso: {
      label: 'Nro. de Caso',
      id: 'nroCaso',
      value: '',
    },
    nombre: {
      label: 'Nombre',
      id: 'nombre',
      value: '',
    },
    apellido: {
      label: 'Apellido',
      id: 'rut',
      value: '',
    },
    telefono: {
      label: 'Teléfono',
      id: 'telefono',
      value: '',
    },
    correoElectronico: {
      label: 'Correo Electrónico',
      id: 'correoElectronico',
      value: '',
    },
    categoria: {
      label: 'Categoría',
      id: 'categoria',
      value: '',
    },
    subCategoria: {
      label: 'Subcategoría',
      id: 'subCategoria',
      value: '',
    },
    titulo: {
      label: 'Titulo',
      id: 'titulo',
      value: '',
    },
    descripcion: {
      label: 'Descripción',
      id: 'descripcion',
      value: '',
    },
    estadoCaso: {
      label: 'Estado del Caso',
      id: '',
      value: '',
    },
    fechaResolucion: {
      label: 'Fecha de Resolución',
      id: '',
      value: '',
    },
    resolucion: {
      label: 'Resolucion',
      id: '',
      value: '',
    },
  };

  lstCategorias: Categorias[] = [];
  ltsSubCategorias: SubCategorias[] = [];
  subfiltradas: SubCategorias[] = [];

  mounted() {
    this.$validator.localize('es', makeValidatorDictionary(this.formFields));
    const self = this;
    let r = this.vr;
    var _ = require('lodash');

    if (this.modoVer) {
      this.getSubCategorias();
    }

    const { formFields } = this;
    formFields.nombre.value = store.state.user.nombre;
    formFields.apellido.value =
      store.state.user.apellidoPaterno + ' ' + store.state.user.apellidoMaterno;
    formFields.correoElectronico.value = store.state.user.email;
    //formFields.telefono.value = store.state.user.nombre;

    this.getCategorias();
    if (this.modoVer) {
      this.getSubCategoriasModoVer();
    }
    this.handleFormChange();
    this.handlecalibracionSeleccionadaChange();

    Validator.extend('telefonoFormato', {
      getMessage(field: any, params: any, data: any) {
        return (
          (data && data.message) ||
          '* Campo contiene caracteres o formato inválido'
        );
      },
      validate(value: any) {
        return new Promise(resolve => {
          resolve({
            valid: r.validaFormatoTelefono(value),
            data: r.validaFormatoTelefono(value)
              ? undefined
              : { message: '* Campo contiene caracteres o formato inválido' },
          });
        });
      },
    });
  }

  @Watch('solicitudSeleccionada', { deep: true })
  handlecalibracionSeleccionadaChange() {
    if (!this.solicitudSeleccionada) {
      return;
    }

    let categoria: any = {};
    let subCategoria: any = {};
    categoria.idCategoria = this.solicitudSeleccionada.idCategoria
      ? this.solicitudSeleccionada.idCategoria
      : '';
    categoria.categoria = this.solicitudSeleccionada.categoria
      ? this.solicitudSeleccionada.categoria
      : '';
    subCategoria.idSubcategoria = this.solicitudSeleccionada.idSubcategoria
      ? this.solicitudSeleccionada.idSubcategoria
      : '';
    subCategoria.subcategoria = this.solicitudSeleccionada.subcategoria
      ? this.solicitudSeleccionada.subcategoria
      : '';

    const { formFields, solicitudSeleccionada } = this;
    formFields.nroCaso.value = this.solicitudSeleccionada.numeroResolucion
      ? this.solicitudSeleccionada.numeroResolucion
      : '';
    formFields.nombre.value = this.solicitudSeleccionada.nombres
      ? this.solicitudSeleccionada.nombres
      : '';
    formFields.apellido.value = this.solicitudSeleccionada.apellidos
      ? this.solicitudSeleccionada.apellidos
      : '';
    formFields.telefono.value = this.solicitudSeleccionada.telefono
      ? this.solicitudSeleccionada.telefono
      : '';
    formFields.correoElectronico.value = this.solicitudSeleccionada.email
      ? this.solicitudSeleccionada.email
      : '';
    formFields.categoria.value = categoria.idCategoria;
    formFields.subCategoria.value = subCategoria.idSubcategoria;
    formFields.titulo.value = this.solicitudSeleccionada.titulo
      ? this.solicitudSeleccionada.titulo
      : '';
    formFields.descripcion.value = this.solicitudSeleccionada.descripcion
      ? this.solicitudSeleccionada.descripcion
      : '';
    formFields.estadoCaso.value = this.solicitudSeleccionada.estado
      ? this.solicitudSeleccionada.estado
      : '';
    formFields.fechaResolucion.value = this.solicitudSeleccionada
      .fechaResolucion
      ? this.solicitudSeleccionada.fechaResolucion
      : '';
    formFields.resolucion.value = this.solicitudSeleccionada.resolucion
      ? this.solicitudSeleccionada.resolucion
      : '';
  }

  @Watch('$validator.errors.items.length')
  handleErrorsChange() {
    this.emitFormChange();
  }

  emitFormChange() {
    emitFormChangeEvent(
      this.$emit.bind(this),
      {
        entity: {
          ContactoNombre: this.formFields.nombre.value,
          ContactoApellidos: this.formFields.apellido.value,
          ContactoTelefono: this.formFields.telefono.value,
          ContactoEmail: this.formFields.correoElectronico.value,
          Titulo: this.formFields.titulo.value,
          Descripcion: this.formFields.descripcion.value,
          Categoria: this.formFields.categoria.value,
          Subcategoria: this.formFields.subCategoria.value,
        } as any, //type CreacionSolicitud
      },
      this
    );
  }

  @Watch('formFields', { deep: true })
  handleFormChange() {
    this.emitFormChange();
  }

  async getCategorias() {
    this.lstCategorias = (await this.cargarCategorias()) || [];
  }

  cargarCategorias() {
    this.loadingService.showLoading();
    return fetchCategorias()
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los tipos de Categorias',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.loadingService.hideLoading());
  }

  async getSubCategorias(categoria?: string) {
    this.bloquedoCategoria = false;
    this.subfiltradas = [];
    this.ltsSubCategorias = (await this.cargarSubcategorias()) || [];
    this.ltsSubCategorias.map(x => {
      if (x.idCategoria == categoria) {
        this.subfiltradas.push(x);
      }
    });
  }

  async getSubCategoriasModoVer(categoria?: string) {
    this.subfiltradas = [];
    this.subfiltradas = (await this.cargarSubcategorias()) || [];
  }

  cargarSubcategorias() {
    this.loadingService.showLoading();
    return fetchSubCategorias()
      .catch(error => {
        if (error.response.status != 404) {
          this.$snotify.error(
            'Ha ocurrido un error al intentar obtener los tipos de Subcategorias',
            { timeout: 3000 }
          );
        }
      })
      .finally(() => this.loadingService.hideLoading());
  }
}
